import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth:800, margin:'0 auto', padding:'20px 0' }}>
      <button onClick={() => navigate(-1)} className="btn-ghost" style={{ marginBottom:20, padding:'8px 16px', fontSize:13 }}>← Back</button>
      <div className="card" style={{ padding:'32px' }}>
        <div style={{ fontFamily:"'Righteous',sans-serif", fontSize:28, marginBottom:4 }} className="brand-text">NAIJAPREDICT</div>
        <h1 style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>Terms & Conditions</h1>
        <div style={{ fontSize:12, color:'var(--muted)', marginBottom:28 }}>Last updated: July 2026</div>

        {[
          {
            title: '1. Acceptance of Terms',
            body: `By accessing or using NaijaPredict ("the Platform"), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the Platform. NaijaPredict is operated by Naija Predict Technologies Limited and is accessible via naijapredict.net and the Telegram bot @NaijaPredict_Bot.`
          },
          {
            title: '2. Eligibility',
            body: `You must be at least 18 years old to use NaijaPredict. By registering, you confirm that you are of legal age in your jurisdiction and that your participation in prediction markets is not prohibited by any applicable law.`
          },
          {
            title: '3. Star Credits (⭐)',
            body: `NaijaPredict uses a virtual currency called Stars (⭐). Stars can be purchased via Flutterwave using Nigerian Naira or earned through correct predictions, referrals, and bonuses. Stars have no cash value outside the Platform. Signup bonus Stars (100 ⭐ given on registration) are non-withdrawable and must be used for staking first. Stars earned from winning predictions are withdrawable subject to the minimum withdrawal limit of 200 ⭐.`
          },
          {
            title: '4. Prediction Markets',
            body: `NaijaPredict hosts skill-based prediction markets where users stake Stars on the outcome of real-world events. All markets are resolved based on publicly verifiable real-world outcomes. Resolution criteria are specified for each market at the time of creation. NaijaPredict reserves the right to void any market if the event is cancelled, results are unverifiable, or in case of technical errors. In the event of a void, all stakes are refunded in full.`
          },
          {
            title: '5. 10% Minimum Profit Guarantee',
            body: `NaijaPredict guarantees that any correct prediction will earn at least 10% profit on the staked amount. If the pool payout would result in less than 10% profit, NaijaPredict will top up the difference automatically. This guarantee does not apply to refunded markets.`
          },
          {
            title: '6. Withdrawals',
            body: `Withdrawals are processed to Nigerian bank accounts via Flutterwave. Minimum withdrawal is 200 Stars (≈ ₦3,000). Maximum withdrawal is 5,000 Stars per day. Withdrawals are subject to a 10-minute cooling period between consecutive requests and a maximum of 3 withdrawals per day. Processing time is up to 24 hours. NaijaPredict reserves the right to request identity verification before processing large withdrawals.`
          },
          {
            title: '7. Prohibited Activities',
            body: `The following are strictly prohibited on NaijaPredict:\n• Using multiple accounts to manipulate markets or exploit bonuses\n• Using bots or automated tools to place stakes\n• Staking with the intent to exploit technical errors\n• Any form of collusion with other users\n• Using disposable or fake email addresses\n• Sharing accounts with other users\n\nViolation of these rules will result in permanent account suspension and forfeiture of all balances.`
          },
          {
            title: '8. Anti-Fraud Policy',
            body: `NaijaPredict employs automated fraud detection systems. Phone numbers are limited to one account per 24-hour period. Suspicious activity may result in account suspension pending review. Fraudulent withdrawals will be reversed and the account permanently banned.`
          },
          {
            title: '9. Limitation of Liability',
            body: `NaijaPredict is not liable for any losses arising from: market outcomes, platform downtime, incorrect predictions, or misuse of the platform. The Platform is provided "as is" without warranties of any kind. NaijaPredict's total liability to any user shall not exceed the Stars balance held in their account at the time of the claim.`
          },
          {
            title: '10. Changes to Terms',
            body: `NaijaPredict reserves the right to modify these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the new Terms. Users will be notified of significant changes via Telegram or email.`
          },
          {
            title: '11. Governing Law',
            body: `These Terms are governed by the laws of the Federal Republic of Nigeria. Any disputes arising from the use of NaijaPredict shall be subject to the exclusive jurisdiction of Nigerian courts.`
          },
          {
            title: '12. Contact',
            body: `For any questions regarding these Terms, contact us at support@naijapredict.net or via Telegram @NaijaPredict_Bot.`
          },
        ].map((s,i) => (
          <div key={i} style={{ marginBottom:24 }}>
            <h2 style={{ fontSize:15, fontWeight:700, color:'var(--orange)', marginBottom:8 }}>{s.title}</h2>
            <p style={{ fontSize:13, color:'var(--text2)', lineHeight:1.8, whiteSpace:'pre-line' }}>{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
